import { render, staticRenderFns } from "./ListCreativeReviews.vue?vue&type=template&id=b5df7aee&scoped=true"
import script from "./ListCreativeReviews.vue?vue&type=script&lang=js"
export * from "./ListCreativeReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df7aee",
  null
  
)

export default component.exports